import { createContext, useContext, useEffect, useState } from 'react'
import { baseURL } from '../services/api'

export const KanguCargobrContext = createContext()

export function KanguCargobrProvider({ children }) {
  const [newestList, setNewestList] = useState([])
  const [dataItems, setDataItems] = useState([])
  const [dataEnterprise, setDataEnterprise] = useState([])
  const [volumes, setVolumes] = useState([])
  const [loading, setLoading] = useState(false)
  const [cubagens, setCubagens] = useState([])
  const [cubagensJamef, setCubagensJamef] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [isFreeShipping, setIsFreeShipping] = useState(false)

  async function getCepClientVerification(cep) {
    if (!dataEnterprise?.ent_cep) return
    try {
      const response = await baseURL.get(
        `/pedido/busca-endereco-cliente/${dataEnterprise?.ent_cep}`
      )

      const dataResp = response.data

      if (dataResp) {
        const { frete_gratis } = dataResp[0]

        if (frete_gratis) {
          const isFree = frete_gratis === 'S' ? true : false
          setIsFreeShipping(isFree)
        }
      }
    } catch (error) {
      console.log('Error in getCepClientVerification', error)
    }
  }

  useEffect(() => {
    getCepClientVerification()
  }, [dataEnterprise?.ent_cep])

  function handleCubagens(e, cubagem, selectAll) {
    if (selectAll) {
      // Selecionar todos os checkboxes
      const allCubagens = dataItems.map((item) => ({
        ...item,
        id: item.id,
      }))

      /* array com todos os valores dos checkboxes */
      setCubagens(allCubagens)

      const allCubagensJamef = allCubagens.map((item) => ({
        ...item.cubagensKangu,
        id: item.id,
      }))
      setCubagensJamef(allCubagensJamef)
    } else {
      // Desmarcar todos os checkboxes
      setCubagens([])
      setCubagensJamef([])
    }
    if (e.target.checked) {
      // Lógica para manipular um checkbox individual (mesmo código existente)
      setCubagens([...cubagens, cubagem])

      const cubagemJamef = {
        ...cubagem?.cubagensKangu,
        id: cubagem?.id,
      }
      setCubagensJamef([...cubagensJamef, cubagemJamef])
    } else {
      // Lógica para desmarcar um checkbox individual (mesmo código existente)
      const newCubagens = cubagens.filter((item) => item.id !== cubagem.id)
      setCubagens(newCubagens)

      const newCubagensJamef = cubagensJamef.filter(
        (item) => item.id !== cubagem.id
      )
      setCubagensJamef(newCubagensJamef)
    }
  }

  function handleAllCubagens() {
    setSelectAll(!selectAll)
    handleCubagens(true, null, !selectAll)
  }

  async function getInfoEnterprise(data) {
    const response = await baseURL.get(
      `/pedido/lista-info-clientes/${data.numero_nota}`
    )

    const dataResp = response.data

    // const cep = await getCepClientVerification(dataResp[0].ent_cep)

    setDataEnterprise(dataResp)

    setCubagens([])

    return response
  }

  async function getInfoItems(data) {
    setLoading(true)
    const response = await baseURL.get(
      `/pedido/busca-info-itens-pagamento/${data.numero_nota}`
    )

    const dataResp = response.data

    const volumes = dataResp.map((item, index) => {
      return {
        width: parseInt(item.INFO_DIMENSAO.Largura) / 100 || 0,
        height: parseInt(item.INFO_DIMENSAO.Altura) / 100 || 0,
        length: parseInt(item.INFO_DIMENSAO.Comprimento) / 100 || 0,
        weight: Math.round(parseFloat(item.INFO_DIMENSAO.PesoCaixa)) || 0,
        value: parseInt(item.INFO_DIMENSAO.ValorVenda) || 0,
        amount: parseInt(item.QT_CX) || 0,
        object_types: ['sobconsulta'],
      }
    })

    const volumesKangu = dataResp.map((item, index) => {
      return {
        largura: parseInt(item.INFO_DIMENSAO.Largura),
        altura: parseInt(item.INFO_DIMENSAO.Altura),
        comprimento: parseInt(item.INFO_DIMENSAO.Comprimento),
        peso: Math.round(parseFloat(item.INFO_DIMENSAO.PesoCaixa)),
        valor: parseInt(item.INFO_DIMENSAO.ValorVenda),
        // amount: parseInt(item.QT_CX),
        tipo: 'C',
      }
    })

    setVolumes({
      cargoBR: volumes,
      Kangu: volumesKangu,
    })

    function generateUniqueId(item, index) {
      const hash = Object.values(item).join('') + index
      let id = 0

      for (let i = 0; i < hash.length; i++) {
        const char = hash.charCodeAt(i)
        id = (id << 5) - id + char // << 5 Faz um shift para a esquerda de 5 bits
        id |= 0 // Converte para um número inteiro de 32 bits
      }

      return Math.abs(id).toString()
    }


    const dataFormatted = dataResp.map((item, index) => {
      const id = generateUniqueId(item, index)

      return {
        id: id,
        codigo: item.CODPROD,
        qtd: parseInt(item.QTDNEG),
        vlr_unit: item.VALOR_UNIT,
        vlr_total: item.VALOR_TOTAL_ITEM,
        nome: item.DESCRICAO,
        peso_item: parseFloat(item.PESOBRUT_PRODUTO),
        cubagem_ped: item.CAIXA,
        quantidade_caixas: item.QT_CX,
        medida: item.CAIXA,
        quantidade_pecas: item.QT_POR_CX,
        peso_caixa: parseFloat(item.VR_CUB_UNIT),
        peso_total: parseFloat(item.VR_CUB_TOT),
        imagem: item.IMAGEM_PROD,
        valor_total_pedido: item.VALOR_TOTAL_PEDIDO,
        sub_tributaria: item.VLR_SUB_TRIBUTARIA,
        cubagem: item.INFO_DIMENSAO,
        calc_kangu: item.CALC_KANGU,
        cubagensCargoBR: {
          width: parseInt(item.INFO_DIMENSAO.Largura) / 100 || 0,
          height: parseInt(item.INFO_DIMENSAO.Altura) / 100 || 0,
          length: parseInt(item.INFO_DIMENSAO.Comprimento) / 100 || 0,
          weight: parseFloat(item.VR_CUB_TOT),
          value: parseFloat(item.INFO_DIMENSAO.ValorVenda).toFixed(2) || 0,
          amount: parseInt(item.QT_CX) || 0,
          object_types: ['sobconsulta'],
          valor_total: item.VALOR_TOTAL_ITEM,
          valor: parseFloat(item.INFO_DIMENSAO.ValorVenda).toFixed(2),
        },
        cubagensKangu: {
          largura: parseFloat(item.INFO_DIMENSAO.Largura),
          altura: parseFloat(item.INFO_DIMENSAO.Altura),
          comprimento: parseFloat(item.INFO_DIMENSAO.Comprimento),
          peso: parseFloat(item.INFO_DIMENSAO.PesoCaixa),
          valor: parseFloat(item.INFO_DIMENSAO.ValorVenda).toFixed(2),
          // amount: parseInt(item.QT_CX),
          tipo: 'C',
          quantidade_caixas: item.QT_CX,
          valor_total: item.VALOR_TOTAL_ITEM,
          pesoCaixa: parseFloat(item.VR_CUB_TOT),
        },

        dimensao: item.INFO_DIMENSAO,
      }
    })

    setDataItems(dataFormatted)

    setLoading(false)
    setCubagens([])
  }

  const summary = cubagens?.reduce(
    (acc, curr) => {
      const { peso_total, quantidade_caixas } = curr

      const pesoTotal = acc.pesoTotal + peso_total || 0
      const quantidadeTotal =
        parseInt(acc.quantidadeTotal) + parseInt(quantidade_caixas) || 0

      return {
        pesoTotal,
        quantidadeTotal,
      }
    },
    {
      pesoTotal: 0,
      quantidadeTotal: 0,
    }
  )

  return (
    <KanguCargobrContext.Provider
      value={{
        dataItems,
        dataEnterprise,
        setNewestList,
        newestList,
        volumes,
        getInfoEnterprise,
        getInfoItems,
        loading,
        summary,
        handleCubagens,
        cubagens,
        cubagensJamef,
        setCubagens,
        setCubagensJamef,
        handleAllCubagens,
        selectAll,
        setSelectAll,
        isFreeShipping,
      }}
    >
      {children}
    </KanguCargobrContext.Provider>
  )
}

export function useKanguCargobr() {
  const context = useContext(KanguCargobrContext)
  return context
}
